define('shared/remote/member/creditCard/get',[
    '$',
    'shared/lib/RSVP', 
    'shared/my/cmus',
    'shared/remote/payment/previous',
    'shared/page/apiVersion'
],
function (
    $, 
    RSVP, 
    getCMus,
    getPreviousPayment,
    getAPIVersion
) {
    'use strict';

    function sendRequestOldHouse(cmus) {
        return new RSVP.Promise(function(resolve, reject){
            var dfd = $.ajax({
                url: '/services/commerce-v4/OfferManager/GetMemberCreditCardInfo',
                type: 'GET',
                dataType: 'json',
                data: {
                    cmus: cmus
                }
            });
            dfd.then(resolve, reject);
        });
    }

    var cachedResult;
    function oldHouse(){
        return getCMus()
            .then(function(cmus){
                return new RSVP.Promise(function(resolve, reject){
                    if(cachedResult){
                        resolve(cachedResult);
                        return;
                    }

                    
                    if(!cmus){
                        resolve(null);
                        return;
                    }

                    var promise = sendRequestOldHouse(cmus);
                    promise.then(
                        function(json){
                            if( json && json.Success === true ) {
                                cachedResult = json.Result;
                                resolve(json.Result);
                            }
                            else {
                                reject('Server side failed to return credit card info');
                            }
                        },
                        function(){
                            reject('Network failure while retrieve credit card info');
                        }
                    );
                });
            });
    }

    return function() {
        var args = Array.prototype.slice.apply(arguments);
        var me = this;
        return getAPIVersion()
            .then(function(apiVersion){
                if (apiVersion === 'new-house') {
                    return getPreviousPayment.apply(me, args);
                }
                else {
                    return oldHouse.apply(me, args);
                }
            });
    };
});
